// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__afzoB","icon__image":"styles_icon__image__q5W6o","skeleton-animation":"styles_skeleton-animation__PmWo2"};